import { render, staticRenderFns } from "./remove-br-modal.vue?vue&type=template&id=5076308b"
import script from "./remove-br-modal.ts?vue&type=script&lang=ts&external"
export * from "./remove-br-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./remove-br-modal.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5076308b')) {
      api.createRecord('5076308b', component.options)
    } else {
      api.reload('5076308b', component.options)
    }
    module.hot.accept("./remove-br-modal.vue?vue&type=template&id=5076308b", function () {
      api.rerender('5076308b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-input/remove-br-modal/remove-br-modal.vue"
export default component.exports